<div mat-dialog-title>
    <div class="title-container">
      <div class="title-modal d-flex f-align-center">
        <h1 class="title-modal">
          Delete Permission
        </h1>
      </div>
      <span class="icon one-icon-close-v2" (click)="close()"></span>
    </div>
  
    <div mat-dialog-content>
      <div class="content-container">
        <span>Are you sure you want to delete the {{ data.permission.name }}?</span>
      </div>
    </div>
  </div>
  
  <div mat-dialog-actions>
    <button class="rp-button rp-outlined rp-primary" (click)="close()">Cancel</button>
    <button class="rp-button rp-filled rp-primary" (click)="delete()">Delete</button>
  </div>
  